module.exports = "<div class=\"row\" *ngIf=\"playlist\" style=\"margin: 0;padding: 0\">\n  <div class=\"col-md-12\" style=\"padding: 0\">\n    <ng-template let-asset ngFor [ngForOf]=\"playlist.playlist_assets\" let-i=\"index\">\n      <iframe *ngIf=\"currentIndex === i\" class=\"img-rounded\" [src]=\"baseUrl + asset.template_url.replace('/', '') | safe\" width=\"{{windowWidth}}\" height=\"{{windowHeight - 5}}\"></iframe>\n    </ng-template>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/playlist-slideshow/playlist-slideshow.component.html
// module id = BsHb
// module chunks = 1